import { render, staticRenderFns } from "./zhyd.vue?vue&type=template&id=981cbc42&scoped=true&"
import script from "./zhyd.vue?vue&type=script&lang=js&"
export * from "./zhyd.vue?vue&type=script&lang=js&"
import style0 from "./zhyd.vue?vue&type=style&index=0&id=981cbc42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981cbc42",
  null
  
)

export default component.exports